import { render, staticRenderFns } from "./VToolbar.vue?vue&type=template&id=3628cc36&scoped=true&"
import script from "./VToolbar.vue?vue&type=script&lang=ts&"
export * from "./VToolbar.vue?vue&type=script&lang=ts&"
import style0 from "./VToolbar.vue?vue&type=style&index=0&id=3628cc36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3628cc36",
  null
  
)

export default component.exports